const IconError = () => {
  return (
    <path
      d="M12.5782 8.855L7.71323 0.745C7.43323 0.28 6.94323 0 6.39823 0C5.85323 0 5.36323 0.28 5.08323 0.745L0.218231 8.855C-0.0667694 9.33 -0.0717695 9.92 0.198231 10.4C0.468231 10.88 0.983231 11.18 1.53323 11.18H11.2632C11.8132 11.18 12.3282 10.88 12.5982 10.4C12.8682 9.92 12.8632 9.325 12.5782 8.855ZM5.89823 3.985C5.89823 3.71 6.12323 3.485 6.39823 3.485C6.67323 3.485 6.89823 3.71 6.89823 3.985V7.19C6.89823 7.465 6.67323 7.69 6.39823 7.69C6.12323 7.69 5.89823 7.465 5.89823 7.19V3.985ZM6.39823 9.295C6.12323 9.295 5.89823 9.07 5.89823 8.795C5.89823 8.52 6.12323 8.295 6.39823 8.295C6.67323 8.295 6.89823 8.52 6.89823 8.795C6.89823 9.07 6.67323 9.295 6.39823 9.295Z"
      fill="currentColor"
      data-testid="icon-error"
    />
  );
};

export default IconError;
